import { useEffect } from 'react';

/**
 * Hook to dynamically control viewport zoom settings based on the current view
 * @param disableZoom - Whether to disable zoom for this view
 * @param override - Optional override to temporarily enable zoom (e.g., when modal is open)
 */
export const useViewportControl = (disableZoom: boolean, override?: boolean) => {
  useEffect(() => {
    const viewport = document.querySelector('meta[name="viewport"]');
    if (!viewport) return;

    // Save original content
    const originalContent = viewport.getAttribute('content');

    // If override is true, always enable zoom (for modals, etc.)
    const shouldDisableZoom = override === true ? false : disableZoom;

    if (shouldDisableZoom) {
      // Disable zoom for this view (like map view without modals)
      viewport.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0');
      console.log('Viewport: Zoom disabled');
    } else {
      // Enable zoom for this view (like chatbot or when modal is open)
      viewport.setAttribute('content', 'width=device-width, initial-scale=1');
      console.log('Viewport: Zoom enabled' + (override ? ' (override active)' : ''));
    }

    // Cleanup: restore original on unmount
    return () => {
      if (originalContent) {
        viewport.setAttribute('content', originalContent);
      }
    };
  }, [disableZoom, override]);
};

export default useViewportControl;